import { Injectable, Input, Directive } from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import { ValidationService } from '@common_libraries/Services/validation/validation.service';

@Directive()
@Injectable()
export class ValidationNotificationModel {
  @Input() control: UntypedFormControl;
  @Input() isSubmitted: boolean = true;

  constructor() { }

  public setControl(formControl: UntypedFormControl) {
    this.control = formControl;
  }

  public setIsSubmitted(isSubmitted: boolean) {
    this.isSubmitted = isSubmitted;
  }  

  public getErrorMessage(): string {
    for (const propertyName in this.control.errors) {
      if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched && this.isSubmitted) {
        return ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
      }
    }
    return null;
  }
}
